import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { RoleConsumer } from '../../../RoleContext'
import PageTitle from '../PageTitle/PageTitle'
import { FormLoader } from '../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import RoleForm from './RoleForm'
import { NamedRoutes } from '../../../routes'
import BreadCrumb from '../BreadCrumb'

const RoleEditContent = ({ pageTitle, adminSectionType }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.RolesAndPermissions'/>,
          link: NamedRoutes[adminSectionType].RolesAndPermissions.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Roles.List.AddRole.Title'/>}/>
      <PageTitle title={pageTitle ?? <FormattedMessage id='Roles.List.AddRole.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <RoleConsumer>
              {({ roleDataLoading, roleDataFailure, roleData, handleRoleSubmit, pageAction }) => (
                <>
                  {!!roleDataLoading && <FormLoader loading={true}/>}
                  {!!roleDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
                  }
                  {pageAction === 'add' ?
                    <RoleForm adminSectionType={adminSectionType} currentDate={{}} onSubmit={handleRoleSubmit}/> :
                    (!!roleData && !!Object.keys(roleData).length &&
                      <RoleForm adminSectionType={adminSectionType} currentDate={roleData}
                                onSubmit={handleRoleSubmit}/>)
                  }
                </>
              )}
            </RoleConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default RoleEditContent
